module.exports = __webpack_public_path__ + "static/media/error.ab111e1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/error.wav
// module id = xFBV
// module chunks = 3